import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../../Contexts/AuthContext/AuthProvider";
import { toast } from "react-toastify";
import axios from "axios";
import MobileWithdrawHistory from "./MobileWithdrawHistory/MobileWithdrawHistory";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import NetWorkSelectForm from "./NetWorkSelectForm";

const MobileWithdrawPage = () => {
  const { authUser } = useContext(AuthContext);

  const [NetworkData, setNetworkData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(
      `https://api.wlfmobile.com/api/user/withdrawal/network/view`,
      {
        method: "GET",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setNetworkData(data.data);
        setLoading(false);
      });
  }, []);

  const [errorMessage, setErrorMessage] = useState({});
  const refSubmitDis = useRef();
  const navigate = useNavigate();

  const handleSubmitData = (event) => {
    event.preventDefault();
    refSubmitDis.current.setAttribute("disabled", true);
    setErrorMessage("");
    const formData = new FormData(event.currentTarget);
    const InpuData = Object.fromEntries(formData);
    const storeData = { user_id: authUser?._id, ...InpuData };

    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    axios
      .post(
        `https://api.wlfmobile.com/api/user/withdrawal/confirm`,
        storeData,
        config
      )
      .then((data) => {
        event.target.reset();
        if (data?.data?.success) {
          Swal.fire({
            title: `${data.data.message}`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/user/dashboard");
            }
          });
        }
        refSubmitDis.current.removeAttribute("disabled");
      })
      .catch((error) => {
        if (error?.response?.data?.success === false) {
          setErrorMessage(error?.response?.data?.errors);
          refSubmitDis.current.removeAttribute("disabled");
        }
      });
  };

  const [WithdrawShow, setWithdrawShow] = useState("Crypto");
  const handleWithdrawShow = (data) => {
    setWithdrawShow(data);
  };

  if (loading) {
    return;
  }

  return (
    <>
      <section className="mobile-py-20-500 user-dashboard">
        <div className="user-profile-area">
          <div className="container my-4">
            <div className="row gutters">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="card h-100">
                  <div className="card-body">
                    <div className="row gutters">
                      <form onSubmit={handleSubmitData}>
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                          <h6 className="mb-3 text-primary text-center">
                            Withdrawal
                          </h6>
                        </div>

                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                          <div className="form-group">
                            <label
                              htmlFor="exampleFormControlInput1"
                              className="form-label"
                            >
                              Select Withdrawal Method
                            </label>
                            <select
                              onChange={(e) =>
                                handleWithdrawShow(e.target.value)
                              }
                              className="form-select"
                            >
                              <option value="Crypto" selected>
                                Crypto Wallet Transfer
                              </option>
                              <option value="Bank">Bank Wire or P2P</option>
                            </select>
                          </div>
                        </div>

                        {WithdrawShow === "Crypto" && (
                          <>
                            {/* <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="exampleFormControlInput1"
                                  className="form-label"
                                >
                                  Select Coin
                                </label>
                                <select name="coin" className="form-select">
                                  <option selected disabled value="">
                                    select
                                  </option>
                                  <option value="BTC">BTC</option>
                                  <option value="ETH">ETH</option>
                                  <option value="USDT">USDT</option>
                                </select>
                                {errorMessage?.coin && (
                                  <span className="text-danger text-start ms-2 ">
                                    {errorMessage?.coin?.msg}
                                  </span>
                                )}
                              </div>
                            </div> */}
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="exampleFormControlInput1"
                                  className="form-label"
                                >
                                  Select Coin
                                </label>
                                <select
                                  name="NetworkType"
                                  className="form-select"
                                >
                                  <option selected disabled value="">
                                    select
                                  </option>

                                  {NetworkData.map((data) => {
                                    return (
                                      <NetWorkSelectForm
                                        data={data}
                                        key={data?._id}
                                      />
                                    );
                                  })}
                                </select>
                                {errorMessage?.NetworkType && (
                                  <span className="text-danger text-start ms-2 ">
                                    {errorMessage?.NetworkType?.msg}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="exampleFormControlInput2"
                                  className="form-label"
                                >
                                  Amount
                                </label>
                                <input
                                  type="number"
                                  name="Amount"
                                  className="form-control"
                                  id="exampleFormControlInput2"
                                  aria-describedby="emailHelp"
                                />
                                {errorMessage?.Amount && (
                                  <span className="text-danger text-start ms-2 ">
                                    {errorMessage?.Amount?.msg}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="exampleFormControlInput2"
                                  className="form-label"
                                >
                                  Withdrawal Address
                                </label>
                                <input
                                  type="text"
                                  name="WithdrawalAddress"
                                  className="form-control"
                                  id="exampleFormControlInput2"
                                  aria-describedby="emailHelp"
                                />
                                {errorMessage?.WithdrawalAddress && (
                                  <span className="text-danger text-start ms-2 ">
                                    {errorMessage?.WithdrawalAddress?.msg}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="row gutters">
                              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="text-center">
                                  <button
                                    type="submit"
                                    id="submit"
                                    className="user-btn1  px-5"
                                    ref={refSubmitDis}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {WithdrawShow === "Bank" && (
                          <>
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="exampleFormControlInput2"
                                  className="form-label"
                                >
                                  Please contact with our customer support to
                                  get the details.
                                  <br />
                                  <br />
                                  Thank You.
                                </label>
                              </div>
                            </div>
                          </>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <MobileWithdrawHistory />
      </section>
    </>
  );
};

export default MobileWithdrawPage;
